import { render } from "./uk6.vue?vue&type=template&id=55ffda3f"
import script from "./uk6.vue?vue&type=script&lang=js"
export * from "./uk6.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__